import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'

type Props = {
  to: string
  title: string
  isActive: boolean
}

/** Subitem de grupo do menu lateral: na sanfona (menu aberto) e no painel do menu recolhido. */
const NavSubLink: FC<Props> = ({ to, title, isActive }) => (
  <li>
    <Link
      to={to}
      className={clsx({ active: isActive })}
      aria-current={isActive ? 'page' : undefined}
    >
      {title}
    </Link>
  </li>
)

export { NavSubLink }
